// src/utils/isPWA.js
export default function isPWA() {
    return window.matchMedia('(display-mode: standalone)').matches ||
           window.navigator.standalone === true; // for iOS
  }
  